<template>
  <div>
    <h1>Мої сповіщення</h1>
    <p>
      Тут Ви отримуватимете сповіщення про дії з Вашими запитами чи зверненнями
    </p>
    <b-overlay
      :show="isLoading"
      :class="{ 'overlay-loading': isLoading }"
      variant="white"
      rounded="sm"
      spinner-variant="warning"
    >
      <template v-if="notifications.length">
        <notificationItem
          @update="getNotifications"
          v-for="n in orderedNotifications"
          :key="n.id"
          :n="n"
        />
      </template>

      <template v-if="!notifications.length && !isLoading">
        <b-alert show variant="primary">
          <h6 class="mb-0">Немає сповіщень</h6>
        </b-alert>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import notificationItem from "@/components/notifications/notification-list-item.vue";
import orderBy from "lodash/orderBy";
export default {
  components: {
    notificationItem,
  },
  data() {
    return {
      isLoading: false,
      notifications: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    orderedNotifications() {
      let notifications = [];

      notifications = orderBy(
        this.notifications,
        (item) => item.created_at.seconds,
        "desc"
      );

      return notifications;
    },
  },
  methods: {
    async getNotifications() {
      this.isLoading = true;
      try {
        var res = await this.$api.get("/frontend/notifications/my");
        if (res.data.success) {
          this.notifications = res.data.data;
          this.$store.dispatch("setNotificationsCount", res.data.data.length);
        }
        this.isLoading = false;
      } catch {
        this.$toast.error("Сталася помилка");
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.getNotifications();
  },
};
</script>

<style lang="scss" scoped></style>
